import { EventEmitter, Injectable, Output, Directive } from '@angular/core'
import { NotificationModel } from '../models/notification.model'
import { NotificationType } from '../enums/notification-type.enum'
import { Subject } from 'rxjs'

@Directive()
@Injectable({
  providedIn: 'root',
})
export class NotificationService {
  @Output() pushNotificationEvent: EventEmitter<NotificationModel> =
    new EventEmitter()

  public readonly dismiss$ = new Subject<NotificationModel>()

  constructor() {}

  public dismissNotification(notification: NotificationModel) {
    this.dismiss$.next(notification)
  }

  public pushSuccess(message: string) {
    this.pushNotification(message, NotificationType.Success)
  }

  public pushWarning(message: string) {
    this.pushNotification(message, NotificationType.Warning)
  }

  public pushError(message: string) {
    this.pushNotification(message, NotificationType.Danger)
  }

  public pushInfo(message: string) {
    this.pushNotification(message, NotificationType.Info)
  }

  private pushNotification(message: string, type: NotificationType) {
    this.pushNotificationEvent.emit(new NotificationModel(message, type))
  }
}
